// @flow
import * as React from 'react';

import {
    Buttons,
    ButtonsContainer,
    Main,
    ModalButton,
    overlayStyle,
    overlayStyleHidding,
    Title,
    TitleContainer,
    Content,
    Arrow,
    ArrowContainer
} from './styles';

import { AsyncButton } from '~/components/widgets/buttons';
import type { AsyncButtonProps } from '~/core/types';
import type { GeneralIcon } from '~/core/constants/icons/general-svg';
import { FormattedMessage } from 'react-intl';
import messages from './intl';
import { noop } from 'lodash/fp';

type Props = {
    asyncButton?: AsyncButtonProps,
    closeButtonMessage?: $npm$ReactIntl$MessageDescriptor,
    closeButtonPrimary?: boolean,
    children: ?React.Element<any>,
    isOpen: boolean,
    onRequestClose: noop,
    title: $npm$ReactIntl$MessageDescriptor,
    showButtons: boolean,
    navigationIcon?: GeneralIcon
};

type State = {
    isOpen: boolean,
    hiding: boolean
};

export default class SideModal extends React.Component<Props, State> {
    static defaultProps = {
        closeButtonMessage: messages.cancel,
        closeButtonPrimary: false,
        showButtons: true
    };

    state = {
        isOpen: this.props.isOpen,
        hiding: false
    };

    componentWillUpdate(nextProps: Props) {
        const { isOpen } = this.props;
        if (isOpen && !nextProps.isOpen) {
            this.setState({ hiding: true });
            setTimeout(() => this.setState({ isOpen: false, hiding: false }), 300);
        } else if (!isOpen && nextProps.isOpen) {
            this.setState({ isOpen: true });
        }
    }

    render() {
        const {
            asyncButton,
            closeButtonMessage,
            closeButtonPrimary,
            children,
            onRequestClose,
            title,
            showButtons,
            navigationIcon
        } = this.props;
        const { hiding, isOpen } = this.state;

        return (
            <Main
                contentLabel=""
                hiding={hiding}
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                shouldCloseOnOverlayClick={false}
                style={{ overlay: hiding ? overlayStyleHidding : overlayStyle }}
            >
                <FormattedMessage {...title}>
                    {message => (
                        <TitleContainer>
                            {navigationIcon && (
                                <ArrowContainer onClick={onRequestClose}>
                                    <Arrow onClick={onRequestClose} type={navigationIcon} />
                                </ArrowContainer>
                            )}
                            <Title navigationIcon={navigationIcon}>{message}</Title>
                        </TitleContainer>
                    )}
                </FormattedMessage>
                <Content showButtons={showButtons}>{children}</Content>
                {showButtons ? (
                    <ButtonsContainer>
                        <Buttons>
                            <FormattedMessage {...closeButtonMessage}>
                                {message => (
                                    <ModalButton alternate={!closeButtonPrimary} onClick={onRequestClose}>
                                        {message}
                                    </ModalButton>
                                )}
                            </FormattedMessage>
                            {asyncButton && <AsyncButton {...asyncButton} />}
                        </Buttons>
                    </ButtonsContainer>
                ) : null}
            </Main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/side-modal/component.js